// 교관 창 「환생」 탭(레인 R): 환생 포인트 배분(공격·HP·치명), 재배분 무료. 정비 서랍 목록 안에 그린다(skillDrawer.ts가 부른다).
import { FONT, el } from './dom';
import { makeRequestId } from './rpgModel';
import { allocRows, allocStep } from './rebirthModel';
import { rebirthStars } from '../shared/rebirth';
import type { SkillTreeEnv } from './skillTree';

const ROW = 'display:flex;align-items:center;gap:8px;min-height:56px;padding:6px 8px;margin-bottom:6px;border:1px solid #4b627c;border-radius:8px;background:linear-gradient(140deg,#10243a,#0a192d);';
const BTN = 'min-width:44px;min-height:44px;border:1px solid #a99159;border-radius:6px;background:linear-gradient(#1a3655,#10253c);color:#f5df9f;font:800 18px ' + FONT + ';';

export function drawRebirthAlloc(list: HTMLElement, env: SkillTreeEnv): void {
  const r = env.view.rebirth;
  const box = el('div', 'display:flex;flex-direction:column;', list);
  box.dataset.testid = 'rebirth-alloc';
  if (!r || r.points <= 0) { el('p', 'color:#bdcce0;line-height:1.6;', box, '환생하면 환생 포인트가 생겨요. 윤회의 문은 마을① 광장에 있어요.'); return; }
  const head = el('div', 'display:flex;align-items:baseline;gap:8px;margin:2px 2px 8px;color:#edce7f;font:800 15px ' + FONT + ';', box);
  el('span', '', head, rebirthStars(r.cycle) + ' ' + r.modeName + ' · ' + r.cycle + '차 환생');
  const free = el('span', 'margin-left:auto;color:#fff;', head, '남은 포인트 ' + r.free + ' / ' + r.points);
  free.dataset.testid = 'rebirth-alloc-free';
  const locked = r.mode !== 'ok';
  const send = (alloc: ReturnType<typeof allocStep>): void => { if (alloc && !locked) env.send({ type: 'rebirthAlloc', alloc, requestId: makeRequestId() }); };
  for (const row of allocRows(r.alloc, r.free)) {
    const line = el('div', ROW, box);
    line.dataset.testid = 'rebirth-alloc-' + row.stat;
    const copy = el('div', 'flex:1;min-width:0;', line);
    el('b', 'display:block;font-size:15px;color:#f1f3f9;', copy, row.name + ' ' + row.effect);
    el('small', 'display:block;font-size:12px;color:#abbcd3;', copy, row.per);
    const dec = el('button', BTN, line, '−'); dec.type = 'button'; dec.dataset.testid = 'rebirth-alloc-' + row.stat + '-dec';
    dec.disabled = locked || !row.canDec; dec.setAttribute('aria-label', row.name + ' 포인트 빼기');
    dec.addEventListener('click', () => send(allocStep(r.alloc, row.stat, -1, r.free)));
    el('span', 'min-width:28px;text-align:center;font:900 18px ' + FONT + ';color:#ffe07a;', line, String(row.value));
    const inc = el('button', BTN, line, '+'); inc.type = 'button'; inc.dataset.testid = 'rebirth-alloc-' + row.stat + '-inc';
    inc.disabled = locked || !row.canInc; inc.setAttribute('aria-label', row.name + ' 포인트 더하기');
    inc.addEventListener('click', () => send(allocStep(r.alloc, row.stat, 1, r.free)));
  }
  const reset = el('button', BTN + 'width:100%;font-size:14px;', box, '배분 초기화 (무료)'); reset.type = 'button';
  reset.dataset.testid = 'rebirth-alloc-reset';
  reset.disabled = locked || r.free === r.points;
  reset.addEventListener('click', () => send({ atk: 0, hp: 0, crit: 0 }));
  if (r.last.kind === 'alloc' && r.last.code !== 'ok' && r.last.message) el('p', 'color:#ffd0ac;font-size:12px;', box, r.last.message).setAttribute('role', 'status');
}
